/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";


const Footer = () => {

    return (
        <footer className="site-footer">
            <div className="container">
                <div className="row">
                    <div className="col-md-4">
                        <h6>About</h6>
                        <p className="text-justify">
                            Welcome to Repose <br /><br />
                            Our goal is to make the world a happier and healthier place.</p>
                    </div>


                    <div className="col-md-2"></div>


                    <div className="col-xs-6 col-md-2">
                        <h6>Get Help</h6>
                        <ul className="footer-links">
                            <li><a href="">FAQ</a></li>
                            <li><a href="">Contact</a></li>
                            <li><a href="">Terms</a></li>
                            <li><a href="">Privacy</a></li>
                        </ul>
                    </div>


                    <div className="col-xs-6 col-md-2">
                        <h6>Company</h6>
                        <ul className="footer-links">
                            <li><a href="">Home</a></li>
                            <li><a href="">About</a></li>
                            <li><a href="">Blog</a></li>
                            <li><a href="">Products</a></li>
                            
                        </ul>
                    </div>

                    <div className="col-xs-6 col-md-2">
                        
                        <div className="right mr-10 md:mr-20 mt-4">
                            
                        </div>
                    </div>
                </div>
            </div>
            <div className="container">
                <div className="row">
                    {/* <div className="col-md-8 col-sm-6 col-xs-12">
                        <ul className="social-icons">
                            <li><a className="fa fa-facebook-f" href="#"><i className="fa fa-facebook-f"></i></a></li>
                            <li><a className="fa fa-facebook-f" href="#"><i className="fa fa-facebook-f"></i></a></li>
                            <li><a className="dribbble" href="#"><i className="fa fa-dribbble"></i></a></li>
                            <li><a href="#"><i className="fa fa-linkedin"></i></a></li>


                        </ul>
                    </div> */}
                    <div className="col-md-12 text-center col-sm-6 col-xs-12">
                        <p className="copyright-text">Copyright &copy; 2021 All Rights Reserved by
                            <a href="#">    Pushpal Ghoshal</a>.
                        </p>
                    </div>
                </div>
            </div>
        </footer>

    );
}

export default Footer;